<template>
    <div>
        <div class="mt-3 col-12">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('registers.events.participants.gridHeaders.moodleResults')}}</div>
            </div>
            <kendo-datasource ref="datasource2"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-model-fields="schemaModelFields"
                              :schema-total="'total'"
                              :schema-data="'data'"
                              :page-size="gridOptions.pageable.size"
                              :server-paging="true"
                              :server-sorting="true"
                              :server-filtering="true"
                              :error="dataSourceError"
                              :requestEnd="datasorceRequestEnd"></kendo-datasource>

            <kendo-grid ref="ParticipantsMoodleCertificates"
                        data-source-ref="datasource2"
                        :pageable="gridOptions.pageable"
                        :navigatable="gridOptions.navigatable"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :column-menu="gridOptions.columnMenu"
                        :scrollable="gridOptions.scrollable"
                        :dataBound="dataBound">
                <kendo-grid-column :field="'id'"
                                   :filterable="false"
                                   :title="$t('registers.events.participants.gridHeaders.moodleId')"
                                   :width="150"
                                   :lockable="true"
                                   :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'fullName'"
                                   :title="$t('registers.events.participants.gridHeaders.name')"
                                   :width="300"
                                   :lockable="true"
                                   :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'email'"
                                   :title="$t('registers.events.participants.gridHeaders.email')"
                                   :width="300"
                                   :lockable="true"
                                   :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'institution'"
                                   :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')"
                                   :width="400"
                                   :lockable="true"
                                   :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'isCertified'"
                                   :title="$t('registers.events.participants.gridHeaders.hasCertificate')"
                                   :width="150"
                                   :template="hasCertificateCellTemplate"
                                   :lockable="true"
                                   :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'timeCompleted'"
                                   :title="$t('registers.events.participants.gridHeaders.certificateDate')"
                                   :width="250"
                                   :format="dateTimeCustomFormat"
                                   :lockable="true"
                                   :locked="false"></kendo-grid-column>
            </kendo-grid>

            <br />
            <div class="alert alert-info" role="alert">
                <h5>{{ $t('certificates.moodleCertificateHelp')}}</h5>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import JSZip from "jszip";
import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
import personalizationService from "../../services/personalization.service";
import { mapGetters } from "vuex";

/*
        Renders the grid in "DejaVu Sans" font family, which is
        declared in kendo.common.css. It also declares the paths to the
        fonts below using <tt>kendo.pdf.defineFont</tt>, because the
        stylesheet is hosted on a different domain.
        */
kendo.pdf.defineFont({
    "DejaVu Sans":
        "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
    "DejaVu Sans|Bold":
        "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
    "DejaVu Sans|Bold|Italic":
        "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
    "DejaVu Sans|Italic":
        "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
    WebComponentsIcons:
        "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf",
});

export default {
    components: {

    },
    created() {
        window.JSZip = JSZip;
    },
    props: {
        showBtns: {
            default: true,
            type: Boolean,
        },
        relatedEventId: {
            default: 0,
            type: Number,
        },
        componentName: {
            default: "ParticipantsMoodleCertificates",
            type: String,
        },
        entryId: {
            type: [Number, String]
        },
    },
    data() {
        return {
            searchQuery: "",
            titleKey: "registers.events.participants.title",
            showUserSettingsForm: false,
            customSettingsLoaded: false,
            schemaModelFields: {
                id: {
                    name: "id",
                    type: "number",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                fullName: {
                    name: "fullName",
                    type: "string",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                email: {
                    name: "email",
                    type: "string",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                institution: {
                    name: "institution",
                    type: "string",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                timeCompleted: {
                    name: "timeCompleted",
                    type: "date",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                isCertified: {
                    name: "isCertified",
                    type: "boolean",
                    editable: false,
                    nullable: false,
                    visible: true,
                },
            },
            gridOptions: {
                ...this.$store.getters.gridOptions,
                editable: {
                    mode: "popup" /* inline, popup */,
                    window: {
                        title: this.$t("organizationalCalendarItem.title"),
                        animation: true,
                    },
                    move: false,
                }
            },
            working: false,
        };
    },
    methods: {
        dataBound(e) {
            if (!this.customSettingsLoaded) {
                this.loadGridSettings();
            }
        },
        dataSourceError(e) {
            this.$vs.notify({
                title: this.$t("notifications.error"),
                text: this.$helpers.kendoDataSourceErrorText(e),
                color: "danger",
                time: this.$store.getters.notificationDuration,
            });
        },
        parameterMap: function (options, operation) {
            if (operation !== "read" && options.models) {
                return {models: kendo.stringify(options.models)};
            } else {
                let newOptions = {
                    eventId: this.entryId,
                    request: options,
                };
                return kendo.stringify(newOptions);
            }
        },
        beforeSend: function (req) {
            if (this.authToken) {
                req.setRequestHeader("Authorization", "Bearer " + this.authToken);
            }
        },
        datasorceRequestEnd(e) {
            if (e.type === "read" && e.response) {
                // 	console.log(e.response[0]);
                // alert(e.respondashboard-ctrlse[0].TaskID);
            }
        },
        isTemplateCellTemplate: function (dataItem) {
            let templateHtml =
                '<span class="badge ' +
                (dataItem.isTemplate ? "badge-success" : "badge-secondary") +
                '">' +
                kendo.htmlEncode(
                    dataItem.isTemplate ? this.$t("yes") : this.$t("no")
                ) +
                "</span>";

            return templateHtml;
        },
        btnsTemplate: function (e) {
            return {
                template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                templateArgs: {
                    ...e,
                    btns: this.gridBtns(e),
                },
            };
        },
        refresh() {
            const grid = this.$refs.ParticipantsMoodleCertificates.kendoWidget();
            if (grid) {
                grid.dataSource.read();
            }
        },
        hasCertificateCellTemplate: function (dataItem) {
            let templateHtml =
                '<span class="badge ' +
                (dataItem.isCertified
                    ? "badge-success"
                    : "badge-secondary") +
                '">' +
                kendo.htmlEncode(
                    dataItem.isCertified ? this.$t("yes") : this.$t("no")
                ) +
                "</span>";

            return templateHtml;
        },
        gridBtns(e) {
            let arr = [];

            if (this.hasParticipantEditRights) {
                // arr.push({
                //    name: "edit",
                //    text: "",
                //    tooltip: this.$t('buttons.edit.btnText'),
                //    class: 'btn btn-primary',
                //    icon: "fas fa-edit",
                //    show: true,
                //    clickHandler: this.editBtnClick
                // });

                arr.push({
                    name: "participantEditNew",
                    text: "",
                    tooltip: this.$t("buttons.edit.btnText"),
                    class: "btn btn-primary",
                    icon: "fas fa-edit",
                    show: true,
                    clickHandler: this.participantEditNewBtnClick,
                });
            }

            return arr;
        },
        getGridOptions() {
            const grid = this.$refs.ParticipantsMoodleCertificates.kendoWidget();
            if (grid) {
                return grid.getOptions();
            }
        },
        loadGridSettings() {
            personalizationService
                .loadGridSettings(this.componentName)
                .then((response) => {
                    try {
                        var options = personalizationService.mergePersonGridSettings(
                            this.getGridOptions(),
                            response.data.settings
                        );

                        let grid = this.$refs.ParticipantsMoodleCertificates.kendoWidget();
                        if (options && grid) {
                            // JSON serialization cannot serializa function, so
                            // all columns with template cannot be load properly
                            let syncWithMoodleColumn = options.columns.find(
                                (col) => col.field === "syncWithMoodle"
                            );
                            if (syncWithMoodleColumn) {
                                syncWithMoodleColumn.template = this.syncedCellTemplate;
                            }

                            let isFromTempRankingColumn = options.columns.find(
                                (col) => col.field === "isFromTempRanking"
                            );
                            if (isFromTempRankingColumn) {
                                isFromTempRankingColumn.template = this.tempRankCellTemplate;
                            }

                            let hasCertificateColumn = options.columns.find(
                                (col) => col.field === "hasCertificate"
                            );
                            if (hasCertificateColumn) {
                                hasCertificateColumn.template = this.hasCertificateCellTemplate;
                            }

                            grid.setOptions(options);

                            if (
                                options.pageable.size !==
                                grid.dataSource.options.pageSize
                            ) {
                                grid.dataSource.pageSize(options.pageable.size);
                                grid.refresh();
                            }

                            const userSettingsEditor = this.$refs.userSettings;
                            if (userSettingsEditor) {
                                userSettingsEditor.setGridSettings(
                                    grid.getOptions()
                                );
                            }

                            // this.$vs.notify({
                            //    title: '',
                            //    text: this.$t('personalSettingsLoaded'),
                            //    color: 'success',
                            //    time: this.$store.getters.notificationDuration,
                            // })
                        }

                        this.customSettingsLoaded = true;
                    } catch (e) {
                        this.customSettingsLoaded = true;
                    }
                })
                .catch((error) => {
                    this.customSettingsLoaded = true;

                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                            this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "danger",
                        time: this.$store.getters.notificationDuration,
                    });
                });
        },
    },
    mounted() {

    },
    computed: {
        ...mapGetters(['dateTimeFormat', 'dateTimeLongFormat', 'isEnVersion', 'authToken']),
        dateTimeCustomFormat() {
            return `{0: ${this.dateTimeLongFormat} }`;
        },
        userSettings() {
            let grid = this.$refs.ParticipantsMoodleCertificates.kendoWidget();
            return grid.getOptions();
        },
        transportSettings() {
            return {
                read: {
                    url: `${this.$store.getters.baseUrl}/api/participant/moodleActivitiesCompletionStatus`,
                    dataType: "json",
                    type: "POST",
                    contentType: "application/json",
                    beforeSend: this.beforeSend,
                },
                parameterMap: this.parameterMap,
            };
        },
    }
};
</script>


<style>
/*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
.k-pdf-export .k-grid {
    font-family: "DejaVu Sans", "Arial", sans-serif;
}

.k-pdf-export .k-filterable .k-grid-filter {
    display: none;
}

.k-pdf-export .k-with-icon .k-header-column-menu {
    display: none;
}

.k-grid .k-grid-header .k-header .k-link {
    height: auto;
}

.k-grid .k-grid-header .k-header {
    white-space: normal;
}

.k-grid-edit,
.k-grid-details,
.k-grid-delete,
.k-grid-pdf,
.k-grid-excel {
    padding: 0;
    margin-bottom: 2px;
}

.fa-cogs {
    padding-left: 21px;
}

</style>
